import { render, staticRenderFns } from "./ComponentStar.vue?vue&type=template&id=53c19e48&"
import script from "./ComponentStar.vue?vue&type=script&lang=js&"
export * from "./ComponentStar.vue?vue&type=script&lang=js&"
import style0 from "./ComponentStar.vue?vue&type=style&index=0&id=53c19e48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports